import { useBankAccountRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetBankAccountCommonInfoQuery } from "../../features/articles/articlesSlice";

export { useBankAccountRoutes };

export default GetDefaultIndex({ title: "حساب‌های بانکی", query: useGetBankAccountCommonInfoQuery });
